import React from "react";
import { AppearanceContext } from "@contexts/AppearanceContext";
import { UserContextType, useUserContext } from "@contexts/UserContext";
import Widget, { WidgetProps } from "../Widget";
import FortuneTeller, { FortuneTellerHeader } from "./FortuneTeller";

type FortuneWidgetProps = WidgetProps;

export default function FortuneWidget(props: FortuneWidgetProps) {
    const { user }: UserContextType = useUserContext();

    return user && user.emailVerified ? (
        // Wrap with Context Provider so this widget is always forced to be dark mode.
        <AppearanceContext.Provider value={{ lightMode: false, setLightMode: () => {} }}>
            <Widget
                headerContent={<FortuneTellerHeader />}
                lightMode={false} // force dark mode styling because widget is transparent
                transparent={true}
                {...props}
            >
                <FortuneTeller />
            </Widget>
        </AppearanceContext.Provider>
    ) : null;
}
